import React, { useEffect, useState } from 'react'
import { Col, Row, Form, Input } from 'reactstrap';
import LoginButton from '../components/buttons/loginButton'
import logo from '../assets/utils/images/logos/logo-confipetrol.png';
import Loading from '../components/modales/loadingModal';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

//API Calls
import { functionsHttpsCallable } from '../utils/FirebaseStorage/firebase';

const getEmpresas = functionsHttpsCallable('general_listadoEmpresas');

let Login = (props) => {

    const [empresas, setEmpresas] = useState([]);
    const [empresaSelected, setEmpresaSelected] = useState();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        document.title = "Iniciar Sesión";
        async function getData() {
            const companies = await getEmpresas();
            setEmpresas(companies.data.data);
            setLoading(false);
        }
        getData()
    }, [])

    const SelectEmpresas = (props) => {
        return (
            <div>
                {/* <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    defaultValue={empresaSelected}
                    onChange={(e) => setEmpresaSelected(empresas.filter(empresa => empresa.nombre === e.target.value)[0]) ?? {}}
                >
                    <option>
                        {'Seleccionar'}
                    </option>
                    {props.empresas.length > 0 ? props.empresas.map(empresa => {
                        return (
                            <option>
                                {empresa.nombre}
                            </option>
                        )
                    }) : <p>Cargando...</p>}
                </Input> */}
                <Col lg='12' md='12' xs="12">
                    <Autocomplete
                        variant = 'outlined'
                        required
                        margin = "dense"
                        options = { empresas }
                        key = {`key_empresa`}
                        id = {`select_empresa`}
                        value = { empresaSelected || null }
                        onChange = { (event, newValue) => {
                            setEmpresaSelected(newValue)
                        }}
                        renderInput = { (params) => (
                            <TextField {...params} variant='outlined' label='Empresa' margin="normal" />
                        ) }
                        getOptionLabel = { (option) => option.nombre }
                        renderOption = { (option) => (
                            <React.Fragment>
                                {option.nombre}
                            </React.Fragment>
                        )}
                    /></Col>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="h-100 bg-login-page bg-animation">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <Col md="8" className="mx-auto app-login-box">
                        <div className="mx-auto mb-3" />
                        <div className="modal-dialog w-100 mx-auto">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="h5 modal-title text-center">
                                        <h4 className="mt-2">
                                            <div
                                                style={{ height: '10vh', backgroundColor: '#a6d4f5', borderRadius:'8px' }}
                                                className='page-title-ico'>
                                                <img src={(empresaSelected !== undefined && empresaSelected.logoUrl) ? empresaSelected.logoUrl : logo} className={"page-title-img"} ></img>
                                            </div>
                                            <span>Ingresa a tu cuenta seleccionando la empresa</span>
                                        </h4>
                                    </div>
                                    {loading ? <Loading /> : <Form>
                                        <Row form>
                                            <Col md={ 12 }>
                                                <div className={"loading-area"}>
                                                    <div className='loading-area-items'>
                                                        <SelectEmpresas empresas = { empresas } />
                                                    </div>
                                                    <div className='loading-area-items-2'>
														<LoginButton empresaSelected={ empresaSelected } setSignedIn={ (e) => { props.setSignedIn(e) }} />															
													</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>}
                                </div>
                            </div>
                        </div>
                        {/* <div>
                            <h4>aca va la version</h4>
                        </div> */}
                    </Col>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Login